import React, { useState, useRef, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { motion } from "framer-motion";
import "antd/dist/reset.css";
import { useNavigate } from "react-router-dom";
import PassDetails from "./Tabs/PassDetails";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { employeeValidationSchema } from "./Data/EmployeeValidation";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import PassportDetails from "./Tabs/PassportDetail";
import {
  addEmployeeDefaultValues,
  EmployeeFieldMapping,
} from "./Data/EmployeeData";
import SalaryDetails from "./Tabs/SalaryDetails";
import AllowanceAndDeductions from "./Tabs/AllowanceAndDeductions";
import Experience from "./Tabs/Components/Experience";
import Inventory from "./Tabs/Components/Inventory";
import Leave from "./Tabs/Leave";
import Education from "./Tabs/Eduction";
import CourseAndCertification from "./Tabs/CourseAndCertification";
import OfficialInformation from "./Tabs/OfficialInformation";
import PersonalInformation from "./Tabs/PersonalInforamtion";
import { format } from "date-fns";
import { Alert, message } from "antd";
import { useCreateOrModifyEmployeeMutation } from "AppQuries/employee/add-employee";
import { Save } from "react-feather";
import VisaDetails from "./Tabs/VisaDetails";
import AccommondationDetails from "./Tabs/AccommodationDetails";
import KidsDetails from "./Tabs/KidsDetails";
import DependantDetails from "./Tabs/DependantDetails";
import WorkingHours from "./Tabs/WorkingHours";
import { toast } from "core/Operations/toast";
import { useGetEmployeeIdQuery } from "AppQuries/employee/get-employee-details";
import PreviewEmployee from "./PreviewEmployee";
import AlertMessage from "Components/UI/AlertMessage";
import * as Yup from "yup";
import ContractDetails from "./Tabs/ContractDetails";
const steps = [
  { id: 1, name: "Official Information", component: OfficialInformation },
  { id: 2, name: "ID Details", component: PassDetails },
  { id: 3, name: "Passport", component: PassportDetails },
  { id: 4, name: "Salary Details", component: SalaryDetails },
  { id: 5, name: "Personal Information", component: PersonalInformation },
  { id: 6, name: "Allowances & Deductions", component: AllowanceAndDeductions },
  { id: 7, name: "Leave Details", component: Leave },
  { id: 8, name: "Working Hours", component: WorkingHours },
  { id: 9, name: "Education", component: Education },
  {
    id: 10,
    name: "Courses & Certifications",
    component: CourseAndCertification,
  },
  { id: 11, name: "Work Experience", component: Experience },
  { id: 12, name: "Assets", component: Inventory },
  { id: 13, name: "Visa Details", component: VisaDetails },
  { id: 14, name: "Accommodation Details", component: AccommondationDetails },
  { id: 15, name: "Kids Details", component: KidsDetails },
  { id: 16, name: "Dependants", component: DependantDetails },
  { id: 17, name: "Contract Details", component: ContractDetails },
];

export default function AddEmployee() {
  const userData = useSelector(loggedInUser);
  const companyCode = userData?.companyCode;
  const locationCode = userData?.locationCode;
  const scrollRef = useRef(null);
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const {
    mutate,
    data,
    error,
    isError,
    isIdle,
    isLoading,
    isPaused,
    isPending,
    isSuccess,
    failureCount,
    failureReason,
    status,
  } = useCreateOrModifyEmployeeMutation();
  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += direction === "next" ? 150 : -150;
    }
  };

  const methods = useForm({
    defaultValues: {
      ...addEmployeeDefaultValues,
      employeeCode: 0,
      uniqueId: "",
      companyCode: companyCode,
      locationCode: locationCode,
      createUser: userData?.userName,
      modifyUser: userData?.userName,
      noOfWorkingDaysPerWeek: userData?.noOfWorkingDaysPerWeek || 5,
      createDate: getCurrentFormattedDate(),
      modifyDate: getCurrentFormattedDate(),
      documentImageDetails: [
        {
          code: 0,
          companyCode: userData?.companyCode,
          employeeCode: 0,
          description: "",
          frontimage: "",
          backimage: "",
          expiryDate: "",
          passportNumber: "",
          issuedDate: "",
          issuedPlace: "",
          createUser: userData?.userName,
          createDate: getCurrentFormattedDate(),
          modifyUser: userData?.userName,
          modifyDate: getCurrentFormattedDate(),
          isActive: true,
        },
      ],
      monday: 8.15,
      tuesday: 8.15,
      wednesday: 8.15,
      thursday: 8.15,
      friday: 7.3,
      saturday: 3.3,
      sunday: 0.0,
    },
    resolver: yupResolver(employeeValidationSchema),
    shouldFocusError: false,
    // mode: "onBlur",
    // mode: "onChange",
    // shouldUnregister: true,
    // reValidateMode: "onSubmit",
  });

  const { data: uniqueId, isLoading: employeeIdLoading } =
    useGetEmployeeIdQuery({ companyCode });

  useEffect(() => {
    if (uniqueId !== null && uniqueId !== undefined) {
      methods.setValue("uniqueId", uniqueId);
      methods.reset({
        ...methods.getValues(),
        uniqueId,
      });
    }
    // }
  }, [uniqueId]);

  const {
    formState: { errors, isDirty, isSubmitted },
    trigger,
    clearErrors,
    setError,
    watch,
    getValues,
  } = methods;
  const StepComponent = steps[step].component;

  const onNext = async () => {
    // const isValid = await trigger();
    //     if (!isValid) return;
    if (step < steps.length - 1) setStep((prev) => prev + 1);
    scroll("next");
  };

  const moveTo = async (id) => {
    // const isValid = await trigger();
    //     if (!isValid) return;

    setStep(id - 1);
    // scroll("next");
  };

  const onBack = () => {
    setStep(step - 1);
    scroll("prev");
  };
  const [showPreview, setShowPreview] = useState(false);
  const previewEmployeeDetails = async () => {
    clearErrors();

    try {
      await employeeValidationSchema.validate(getValues(), {
        abortEarly: false,
      });

      setShowPreview(true);
    } catch (err) {
      setShowPreview(false);

      const formErrors = {};

      err.inner.forEach((error) => {
        setError(error.path, {
          type: "manual",
          message: error.message,
        });

        formErrors[error.path] = {
          type: "manual",
          message: error.message,
        };
      });

      onError(formErrors);

      // err.inner.forEach((error) => {
      //   setError(error.path, {
      //     type: "manual",
      //     message: error.message,
      //   });
      // });
    }
  };
  const onSubmit = (input) => {
    const employeeLogin = [
      {
        companyCode: input.companyCode,
        employeeID: input.employeeCode,
        userName: input?.employeeLogin?.[0]?.userName,
        password: input?.employeeLogin?.[0]?.password,
        userType: input?.employeeLogin?.[0]?.userType,
        defaultLoginLatitude: 1,
        defaultLoginLongitude: 1,
        loginAttempts: 1,
        lastLogin: format(new Date(), "yyyy-MM-dd"),
        createdUser: userData.userName,
        createdDate: getCurrentFormattedDate(),
        updatedUser: userData.userName,
        updatedDate: getCurrentFormattedDate(),
        isActive: input?.employeeLogin?.[0]?.isActive,
        isLock: input?.employeeLogin?.[0]?.isLock,
        deviceId: "",
        DeviceIMEINumber: "",
        isFirstLogin: true,
        loginType: input?.employeeLogin?.[0]?.loginType,
        // locationCode: input?.locationCode,
      },
    ];

    const cpfAccountDetails =
      watch("employeeType") !== "3"
        ? input.cpfAccountDetails.map((item) => ({
            ...item,
            companyCode: input.companyCode,
            nric: input.nric,
            employeeAmount: 0,
            employerAmount: 0,
            createdUser: userData.userName,
            createdDate: getCurrentFormattedDate(),
            modifyUser: userData?.userName,
            modifyDate: getCurrentFormattedDate(),
          })) || []
        : [];

    const passTypeDetails = [
      {
        companyCode: input?.companyCode,
        employeeCode: input?.employeeCode,
        passTypeID: 0,
        passCode: Number(input?.passCode) || 0,
        nricNumber: input?.passTypeDetails[0]?.nricNumber || "",
        photoIdBarcode: input?.passTypeDetails[0]?.photoIdBarcode || "",
        issuedDate: input?.passTypeDetails[0]?.issuedDate || "",
        sector: input?.passTypeDetails[0]?.sector || "",
        dateOfApplication: input?.passTypeDetails[0]?.dateOfApplication || "",
        idExpiryDate: input?.passTypeDetails[0]?.idExpiryDate || "",
        sPassNumber: input?.passTypeDetails[0]?.sPassNumber || "",
        workPermitNumber: input?.passTypeDetails[0]?.workPermitNumber || "",
        workPermitRenewalDate:
          input?.passTypeDetails[0]?.workPermitRenewalDate || "",
        levyTypes: input?.passTypeDetails[0]?.levyTypes || "",
        levyAmountTypes: input?.passTypeDetails[0]?.levyAmountTypes || "",
        levyAmount: input?.passTypeDetails[0]?.levyAmount || 0,
        pcpExpiryDate: input?.passTypeDetails[0]?.pcpExpiryDate || "",
        pcpClinic: input?.passTypeDetails[0]?.pcpClinic || "",
        typeOfVisa: input?.passTypeDetails[0]?.typeOfVisa || "",
        purpose: input?.passTypeDetails[0]?.purpose || "",
        remarks: input?.passTypeDetails[0]?.remarks || "",
        frontImage: input?.passTypeDetails[0]?.frontImage || "",
        backImage: input?.passTypeDetails[0]?.backImage || "",
        isActive: input?.passTypeDetails[0]?.isActive || false,
        createUser: input?.passTypeDetails[0]?.createUser || userData?.userName,
        createDate:
          input?.passTypeDetails[0]?.createDate || getCurrentFormattedDate(),
        modifyUser: userData?.userName,
        modifyDate: getCurrentFormattedDate(),
        sgPassFrontImage: input?.passTypeDetails[0]?.sgPassFrontImage || "",
        sgPassBackImage: input?.passTypeDetails[0]?.sgPassBackImage || "",
      },
    ];

    let employeeData = {
      ...input,
      otDaySalary: Number(input?.otDaySalary),
      otHourlySalary: Number(input?.otHourlySalary),
      basicSalary: Number(input?.basicSalary),
      passCode: Number(input?.passCode),
      hpno: input?.hpno.toString(),
      employeeLogin: employeeLogin,
      cpfAccountDetails: cpfAccountDetails,
      passTypeDetails: passTypeDetails,

      // isActive: input?.employmentStatus === 3 ? true : false,
      residentialType:
        input?.employeeType === "3" ? "OS" : input?.residentialType,
      // passTypeDetails: [
      //   {
      //     ...input?.passTypeDetails[0],
      //     passTypeID: Number(input?.passTypeDetails[0].passTypeID) || 0,
      //     passCode: Number(input?.passTypeDetails[0].passCode) || 0,
      //     levyAmount:
      //       input?.passTypeDetails[0].levyAmount === ""
      //         ? 0
      //         : input?.passTypeDetails[0].levyAmount,
      //   },
      // ],
      alternateWorkingHours:
        input?.alternateWorkingHours?.[0] &&
        Object.keys(input?.alternateWorkingHours[0]).length > 0
          ? input?.alternateWorkingHours[0]?.isAlternate === true
            ? input?.alternateWorkingHours
            : []
          : [],
    };

    mutate(employeeData, {
      onSuccess: (data) => {
        if (data[0]?.response === false) {
          toast.error(data[0]?.errorMessage);
        } else {
          setShowPreview(false);
          toast.success("Employee created successfully.");
          setTimeout(
            () => navigate(`${all_routes.employee}${all_routes.employee_list}`),
            1000
          );
        }
      },
      onError: (error) => {
        toast.warning(error.message || "Something went wrong.");
      },
    });
  };

  const onError = (errors) => {
    setShowPreview(false);
    const firstErrorField = Object.keys(errors)[0];
    const tabIndex = EmployeeFieldMapping[firstErrorField];

    if (tabIndex !== undefined) {
      setStep(tabIndex);
    }
  };

  useEffect(() => {
    // Get the first field with error
    if (errors) {
      const firstErrorField = Object.keys(errors)[0];
      const tabIndex = EmployeeFieldMapping[firstErrorField];

      if (tabIndex !== undefined) {
        setStep(tabIndex);
      }
    }
  }, [errors]);

  useEffect(() => {
    const checkOverflow = () => {
      if (scrollRef.current) {
        const hasOverflow =
          scrollRef.current.scrollWidth > scrollRef.current.clientWidth ||
          scrollRef.current.scrollHeight > scrollRef.current.clientHeight;
        setIsOverflowing(hasOverflow);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        <form
          onSubmit={() =>
            methods.handleSubmit(onSubmit, onError)({ shouldFocusError: false })
          }
        >
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Add Employee</h4>
                <h6>Create new employee</h6>
              </div>
            </div>

            <div className="page-btn">
              {/* {step >= 4 && ( */}
              <button
                className="btn btn-added"
                onClick={previewEmployeeDetails}
                type="button"
                // onClick={methods.handleSubmit(onSubmit, onError)}
                // type="submit"
                disabled={isPending}
              >
                {isPending ? (
                  <>
                    <i className="fas fa-spinner fa-spin me-2" /> Loading...
                  </>
                ) : (
                  <>
                    <Save className="me-2" />
                    Preview & Save
                  </>
                )}
              </button>
              {/* )} */}
            </div>
            <div className="page-btn">
              <button
                className="btn btn-secondary"
                onClick={() =>
                  navigate(`${all_routes.employee}${all_routes.employee_list}`)
                }
                type="button"
              >
                <i className="fas fa-reply me-2"></i> Back
              </button>
            </div>
          </div>
          {Object.keys(errors).length > 0 && (
            <div className="mt-2">
              <AlertMessage
                message="Some required fields are missing"
                type="warning"
              />
            </div>
          )}

          <FormProvider {...methods}>
            <div className="card border-0 mb-0">
              <div className="card-body">
                {/* <ul className="nav nav-tabs justify-content-center mb-4">
                {steps.map((item, index) => (
                
                  <li key={item.id} className="nav-item me-0">
                    <button
                      className={`nav-link step-${item.id} py-1 ${
                        index === step ? "active" : ""
                      }`}
                      type="button"
                      disabled
                    >
                      <motion.div
                        className="w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition"
                        initial={{ scale: 0.9 }}
                        animate={{ scale: index === step ? 1.1 : 1 }}
                      >
                        {item.name}
                      </motion.div>
                    </button>
                  </li>
                ))}
              </ul> */}
                <div className="d-flex align-items-center">
                  {/* Previous Button */}
                  <button
                    className={`btn btn-secondary btn-sm btn-rounded-pills btn-outlined ${
                      isOverflowing !== true ? "nav-scroller" : ""
                    } `}
                    type="button"
                    onClick={() => scroll("prev")}
                  >
                    &lt;
                  </button>
                  &nbsp;
                  <div
                    ref={scrollRef}
                    style={{
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                      scrollbarWidth: "none",
                      display: isOverflowing === true ? "flex" : "grid",
                      gap: "10px",
                      flexGrow: 1,
                      padding: "10px",
                    }}
                  >
                    <ul
                      className="nav nav-tabs justify-content-center mb-5 tab-style-3"
                      id="myTab2"
                      role="tablist"
                    >
                      {steps?.map((item, index) => (
                        <li
                          className="nav-item me-0"
                          // role="presentation"
                          key={item.id}
                        >
                          <button
                            className={`nav-link step-${item.id} py-1 ${
                              index === step
                                ? "active"
                                : index < step
                                ? "completed"
                                : "in-completed"
                            }`}
                            id={item.id}
                            type="button"
                            // disabled
                            onClick={() => moveTo(item.id)}
                          >
                            <motion.div
                              className={`w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition`}
                              initial={{ scale: 0.9 }}
                              animate={{ scale: index === step ? 1.1 : 1 }}
                              transition={{ duration: 0.9 }}
                            >
                              {item.name}
                            </motion.div>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  &nbsp;
                  <button
                    className={`btn btn-secondary btn-sm btn-rounded-pills btn-outlined ${
                      isOverflowing !== true ? "nav-scroller" : ""
                    } `}
                    onClick={() => scroll("next")}
                    type="button"
                  >
                    &gt;
                  </button>
                </div>
              </div>
            </div>
            <div className="card border-0">
              <div className="card-body add-product pb-0">
                {/* Step Content */}
                <motion.div
                  key={step}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="text-editor add-list">
                    <StepComponent />
                  </div>
                </motion.div>

                {/* Navigation Buttons */}

                <div className="card-footer">
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    {step > 0 && (
                      <button
                        className="btn btn-outline-secondary"
                        onClick={onBack}
                        type="button"
                      >
                        Back
                      </button>
                    )}

                    {step < steps.length - 1 ? (
                      <button
                        className="btn btn-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          onNext();
                        }}
                        type="button"
                      >
                        Save & Continue
                      </button>
                    ) : (
                      <button
                        className="btn btn-success"
                        // onClick={methods.handleSubmit(onSubmit)}
                        onClick={previewEmployeeDetails}
                        disabled={isPending}
                        type="button"
                      >
                        {isPending ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2" />
                            Loading...
                          </>
                        ) : (
                          <>
                            <Save className="me-2" />
                            Submit
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <PreviewEmployee
              mode="I"
              onSubmit={onSubmit}
              onError={onError}
              show={showPreview}
              handleClose={() => setShowPreview(false)}
              status={isPending}
            />
          </FormProvider>
        </form>
      </div>
    </div>
  );
}
